import { Role } from '@auth/user';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';
import { Navigate } from 'react-router';

const Transfer = lazy(() => import('./Lists/Transfer'));
const TransfersDashboard = lazy(() => import('./Dashboard/TransferDashboard'));




const TransferRoute: FuseRouteItemType = {
    path: 'webrar/transfers',
    auth: [Role.Admin, Role.Domain_Manager, Role.Technical_Support],
    children: [
        {
            index: true,
            element: <Navigate to="/webrar/transfers/incoming" replace />
        },
        {
            path: 'lists',
            element: <Transfer />,
            settings: {
                layout: {
                    config: {
                        toolbar: {
                            title: 'Bulk Transfer',
                            showCrumbs: false,
                            helpName: 'Bulk Transfer Queues',
                        }
                    }
                }
            }
        },
        {
            path: 'dashboard',
            element: <TransfersDashboard />,
            settings: {
                layout: {
                    config: {
                        toolbar: {
                            title: 'Bulk Transfer',
                            showCrumbs: false,
                            helpName: 'Bulk Transfer Dashboard',
                        }
                    }
                }
            }
        }
    ]
};

export default TransferRoute;
